import { translate } from '@openclassrooms/translations';
import { getPathName, ROUTES } from '@openclassrooms/routing';
import { TOC_TYPES } from '@openclassrooms/ui-web/table-of-content';

import { CourseType, ChapterType } from '../types';
import tocItemToUrl from './tocItemToUrl';

interface FooterInformation {
  label: string;
  url: string;
}

const getFooterInformation = (nextChapter: ChapterType, course: CourseType): FooterInformation => {
  if (!nextChapter) {
    return {
      label: translate('next_cta.end'),
      url: getPathName(
        ROUTES.COURSES.DETAIL,
        {
          courseIdSlug: `${course.id}-${course.slug}`,
        },
        false
      ),
    };
  }

  const url = tocItemToUrl(course, {
    id: nextChapter.id,
    type: nextChapter.type,
    title: nextChapter.title,
  });

  const label =
    nextChapter.type === TOC_TYPES.MCQ
      ? translate('next_cta.quiz')
      : translate('course.chapter.cta.next');

  const urlWithParams = `${url}${window.location.search}`;

  return {
    label,
    url: urlWithParams,
  };
};

export default getFooterInformation;
